/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 *
 * Google CDN, Latest jQuery
 * To use the default WordPress version of jQuery, go to lib/config.php and
 * remove or comment out: add_theme_support('jquery-cdn');
 * ======================================================================== */

//{sort: 'price-descending'}

var yourDesigner;
var p13n_versions = [];
var current_version = null;
var p13n_version_pricing = [0];
var elements_count = 0;
var current_view_element_count = 0;
var current_p13n_version = 0;
var percentage = 0;
var percentage_part = 0;
var original_product = {};
var original_basic_product = {};
var bp13n_versions = [];
var bp13n_version_pricing = [0];
var bp13n_preview = false;
var current_bp13n_version = 0;
//var min_store_stock = 5;
var hex_names = {};
var max_lead_time = 0;
var cart_token = null;
var swatch = "";
var next;


var ic = false;
var has_advanced = false;
var has_basic = false;
var has_layout = false;
var has_image = false;
var has_chosen = false;
var lid = false;
var is_editing = false;
var edit_cart;
var cart_to_delete = false;
var cart_to_verify = false;

var pricing_types;
var product_p13n_type;
var api_url = 'https://api.thingsengraved.com/api';

var infowindow;
var $markgroups = {};
var gmap;
var $allmarkers = [];
var update_timeout = null;
var current_cart = [];
var gw_items = [];
var gw_items_length = 0;
var gw_current_product_selected = null;
var gw_current_product_selected_has_p13n = false;
var gw_current_product_selected_qty = null;
var gw_current_product_selected_wrapping = null;
var gw_current_product_selected_to = null;
var gw_current_product_selected_from = null;
var gw_current_product_selected_message = null;
var gw_current_item_index = 1;
var gw_add_max = false;
var home_store;
var is_adding_to_cart = false;
var temp_product = null;

var proceed_to = 'cart';
//collection variables

var filterable_current_sort = 'manual';
var filterable_current_per_page = 12;
var filterable_current_page = 0;

$(function() {
/* Find a Retailer Popup */
  if ($('body.product').length == 1) { // product page
    home_store = localStorage.getItem("homeStore");


    if (home_store && home_store != 'undefined') {
      home_store = JSON.parse(home_store);

      $('.home-store--name').text(home_store.mall);

      updateChangeHomeStore(true);


      update_product_stock_indicator();

    } else {
      $('#home_store--not-set').show();
    }

    initAutocomplete();

    function initAutocomplete() {

      var input = document.getElementById('pac-input');
      var options = {
        componentRestrictions: {country: 'ca'}
      };

      var searchBox = new google.maps.places.Autocomplete(input,options);

      searchBox.addListener('place_changed', function() {
        var places = [searchBox.getPlace()];

        if (places.length == 0) {
          return;
        }

        here_marker_pos = {
          lat: places[0].geometry.location.lat(),
          lng: places[0].geometry.location.lng()
        };

        $('#home_store--current-location').text(places[0].name);

        $.ajax({
          url: 'https://api.thingsengraved.com/api/stock/' + current_sku + '/nearby/' + here_marker_pos.lat + '/' + here_marker_pos.lng,
          //dataType: "jsonp",
          method: 'get',
          crossDomain: true,
          })
          .done(function(data) {
            $('#stores-close-to').text(places[0].name);

            if(JSON.parse(data).length == 0){

              $('ul.store__list').html("<li><h3>No stock available at any location</h3></li>");

            } else {

              refresh_store_list(data);
              updateChangeHomeStore(true);

            }
        });
      });

    function refresh_store_list(data) {
      
        $('.store__list').html('');
        var empty = true;

        $.each(JSON.parse(data), function( key, v ) {

            if (v.quantity < min_store_stock) {
              return;
            }

            empty = false;
            safe = v;
            safe.mall = v.mall.replace('\'', '&#39;');
            safe.address = v.address.replace('\'', '&#39;');

            if(home_store && v.whsenum == home_store.whsenum){
              // is home
            }

            var isHome = home_store && v.whsenum == home_store.whsenum

            var distance = '';
            if (typeof v.distance !== 'undefined') {

              if (v.distance > 10) {
                distance = '<span class="text">' + v.distance.toFixed(0)+'&nbsp;km</span> away';
              } else {
                distance = '<span class="text">' + v.distance.toFixed(2)+'&nbsp;km</span> away';
              }
            }

            $('.store__list').append('<li id="store_'+v.whsenum+'" class="'+(home_store && v.whsenum == home_store.whsenum ? 'home ' : '' )+'">'+
              '<p class="store__name">'+
                '<span class="store__home-store heading--small">' + '' + (isHome ? 'Your Home Store' : '') + '</span>' +
                '<a class="btn__details text" href="#" data-store-id="' + v.whsenum + '" >' + v.name + '<br/>(' + v.mall+ ')</a>'+
              '</p>'+
              '<p class="store__location">'+
                '<a href="https://www.google.ca/maps/search/' + encodeURIComponent(v.address + ',' + v.city + ',' + v.prov + ' ' + v.pcode) + '"><span class="no-margin">'+v.address+'</span><span class="no-margin">'+v.city+', '+v.prov+' '+v.pcode+'</span></a>'+
              '</p>'+
              '<a href="tel:'+v.phone+'">'+v.phone+'</a>'+
              '<p class="store__distance">'+ distance + '</p>'+
              '<div class="store__home">'+
                ''+ (home_store && v.whsenum == home_store.whsenum ? '' :
                '<a data-store=\'' + JSON.stringify(safe) + '\' class="btn btn__home-store btn__tertiary js-make-home-store">Set Home Store</a>')+
              '</div>'+
            '</li>');

            $('.btn__home-store, .a__home-store').off('click');
            $('.btn__home-store, .a__home-store').on('click',function(){
              home_store = $(this).data('store');
              localStorage.setItem('homeStore', JSON.stringify(home_store));
              $('.home-store--name').text(home_store.mall);
              $('.modal__close').click();
              update_product_stock_indicator();
            });

        });

        if(data == '[]' || empty){
          $('.store__list').append('<li><p>Sorry, this product is currently out of stock at all our location.</p></li>');
          return;
        }

        $('.btn__details').on('click', function(e){
          e.preventDefault();

          $('#store_details').addClass('modal__open');
          $('#store_details .modal__body').hide();
          $('#store_details .modal__body--loading').show();
          
          $.ajax({
            url: 'https://api.thingsengraved.com/api/store/' + $(this).data('store-id'),
            method: 'get',
            crossDomain: true
            })
            .done(function(data) {
              data = JSON.parse(data);
              $('#store__mall').html(data.Mall);
              $('#store__mall-address').html(data.Store_Address.Address + "<br />" + data.Store_Address.City + ", " + data.Store_Address.Province + ' ' + data.Store_Address.Postal_Code + "<br />" + data.Phone_Number);
              var hours_string = '';

              $.each(data.Store_Hours.Summary, function(index,hour){
                hours_string += "<p>" + hour + "</p>";
              });

              $('#store__mall-hours').html(hours_string);

              var services_string = '';

              $.each(data.Services, function(index,service){
                services_string += "<li>" + service.Description + "</li>";
              });

              $('#store__services').html(services_string);

              $('#store__image').attr('style','background-image: url(' + data.Images[0] + ')');

              $('.modal__body').show();
              $('.modal__body--loading').hide();
            });

          setTimeout(function(){
            $('#store_details .modal').removeClass('hide');
            $('#store_details .modal').addClass('transition');
          });

          setTimeout(function(){
            $('#store_details .modal').removeClass('transition');
            $('#store_details .modal').addClass('visible');
          }, 50);

        });

        $('#store_details .modal__close-details').on('click', function(e){
          e.preventDefault();
          e.stopPropagation();

          $('#store_details.modal__containter').removeClass('modal__open');
          $('#store_details .modal').removeClass('visible');
          $('#store_details .modal').addClass('transition');

          setTimeout(function(){
            $('#store_details .modal').removeClass('transition');
            $('#store_details .modal').addClass('hide');
          },500);
        });
        $(document).keydown(function(e){

          if (e.keyCode == 27) {
            $('#store_details.modal__containter').removeClass('modal__open');
            $('#store_details .modal').removeClass('visible');
            $('#store_details .modal').addClass('transition');

            setTimeout(function(){
              $('#store_details .modal').removeClass('transition');
              $('#store_details .modal').addClass('hide');
            }, 500);
          }
        });
      //}

    }


    $('.btn__store').on('click', function(e){

      e.preventDefault();
      e.stopPropagation();

      if (home_store){

          $('.home_store--name').text(home_store.mall);
          $('#home_store--current-location').text(home_store.mall);

          $.ajax({
                    url: 'https://api.thingsengraved.com/api/stock/' + current_sku + '/nearby/' + home_store.whsenum,
                    method: 'get',
                    crossDomain: true,
                    })
                    .done(function(data) {
                      $('#stores-close-to').text('Your Current location');
                      refresh_store_list(data); //refresh store list need new for stock based
                      updateChangeHomeStore(true);
          });

      } else if(typeof google == 'undefined'){

      } else if (false) {
        navigator.geolocation.getCurrentPosition(function(position) {
          pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };

          $.ajax({
            url: 'https://api.thingsengraved.com/api/stock/' + current_sku + '/nearby/' + pos.lat + '/' + pos.lng,
            method: 'get',
            crossDomain: true,
            })
            .done(function(data) {
              $('#stores-close-to').text('Your Current location');
              refresh_store_list(data);
              updateChangeHomeStore(true);
            });
        });
      }

      setTimeout(function(){
        $('.modal__containter[data-modal="home_store"]').addClass('transition');
        $('.modal__containter[data-modal="home_store"] .modal').removeClass('hide');
        $('.modal__containter[data-modal="home_store"] .modal').addClass('transition');
      });

      setTimeout(function(){
        $('.modal__containter[data-modal="home_store"]').removeClass('transition');
        $('.modal__containter[data-modal="home_store"]').addClass('modal__open');
        $('.modal__containter[data-modal="home_store"] .modal').removeClass('transition');
        $('.modal__containter[data-modal="home_store"] .modal').addClass('visible');
        }, 50);
      });

      var pos;
      var here_marker_pos = false;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position) {
          here_marker_pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
        });
      }
    }
  }

  $('.btn__unseen__go-back').on('click',function(){
    $('.modal__close').click();
  });

  $('.btn__unseen__proceed').on('click',function(){
    $.each(p13n_versions, function(i,version){
      if(typeof p13n_versions[i].unseen !== 'undefined'){
        delete p13n_versions[i].unseen;
      }

    });
    $('.modal__containter[data-modal="unseen"].modal__containter').removeClass('modal__open');
    $('.modal__containter[data-modal="unseen"] .modal').removeClass('visible');
    $('.modal__containter[data-modal="unseen"] .modal').addClass('transition');
    setTimeout(function(){
      $('.modal__containter[data-modal="unseen"] .modal').removeClass('transition');
      $('.modal__containter[data-modal="unseen"] .modal').addClass('hide');
    },1);
    setTimeout(function(){
      $('#p13n_add_to_bag_bottom').trigger('click');
    }, 2);
  });
















  $('.store-list__scroll').on('click', function(){
    var store_list_item = $('.store__list li').outerHeight(),
        store_list_margin = $('.store__list li:nth-child(2)').css('margin-top'),
        store_list_scrollHeight = store_list_item + parseInt(store_list_margin, 10),
        store_list_topPos = $('.store__list').scrollTop();
    $(".store__list").animate({
        scrollTop: store_list_scrollHeight + store_list_topPos
    }, 600);
  });

  var here_marker_pos = false;
  home_store = false;

  home_store = localStorage.getItem("homeStore");

  if(home_store && home_store != 'undefined'){

    new_home_store = JSON.parse(home_store);
    setHomeStore(new_home_store,true);

  } else if (typeof google == 'undefined') {

  } else if (false) {
    navigator.geolocation.getCurrentPosition(function(position) {
      here_marker_pos = {
        lat: position.coords.latitude,
        lng: position.coords.longitude
      };

      var geocoder = new google.maps.Geocoder();
      var postal_code = false;
      geocoder.geocode({'location': here_marker_pos}, function(results,status){
        if(postal_code == false){
          $.each(results,function(index,location){
            $.each(location.address_components,function(index,component) {
              switch(component.types[0]) {
                case 'postal_code':
                case 'postal_code_prefix':
                  postal_code = component.long_name;
                  if(postal_code.length == 3){
                    postal_code += '2A2';
                  }
                  break;
              }
            });
          });
        }
        if(postal_code !== false){
          var data = {
            'province_code': null,
            'city':null,
            // 'pcode': postal_code,
            'lat': here_marker_pos.lat,
            'lng': here_marker_pos.lng,
            'range': 50
          };

          if(province !== false  && results[0].location.address_components.length == 2 ){
            data = {
              'province_code': province,
              'city':null,
              'pcode': null,
              'lat': null,
              'lng': null,
              'range': null
            };
          }

          // Clear out the old markers.
          $.ajax({
            url: 'https://web01.thingsengraved.ca/_apps/locator_ajax.php?get-store-data',
            //dataType: "jsonp",
            method: 'post',
            crossDomain: true,
            data:data
            })
            .done(function(data) {
              $('#stores-close-to').text('Your Current location');
              refresh_map_markers(data);
          });
        }
      });
    }, function() {
      // Clear out the old markers.
      $.ajax({
        url: 'https://web01.thingsengraved.ca/_apps/locator_ajax.php?get-store-data',
        //dataType: "jsonp",
        method: 'post',
        crossDomain: true,
        })
        .done(function(data) {
          refresh_map_markers(data);
      });
    });

  } else {

    $.ajax({
      url: 'https://web01.thingsengraved.ca/_apps/locator_ajax.php?get-store-data',
      //dataType: "jsonp",
      method: 'post',
      crossDomain: true,
      })
      .done(function(data) {
        refresh_map_markers(data);
    });
  }


  function setHomeStore(new_home_store, skip){
    home_store = new_home_store;

    if(!skip){
      localStorage.setItem('homeStore', JSON.stringify(new_home_store));
    }

    $('.home-store__wrapper').html('          <p class="heading__primary--x-small home-store__title">            <span class="circle">            <svg version="1.1" class="icon icon__star" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="99.1px" height="94.5px" viewBox="0 0 99.1 94.5" style="enable-background:new 0 0 99.1 94.5;" xml:space="preserve">  <path d="M20.3,94c-0.3,0-0.6-0.1-0.9-0.3c-0.5-0.3-0.7-0.9-0.6-1.5l5.4-32L1,37.8c-0.4-0.4-0.6-1-0.4-1.5    c0.2-0.5,0.6-0.9,1.2-1l32.1-4.8L48.1,1.3c0.3-0.5,0.8-0.8,1.3-0.8c0,0,0,0,0,0c0.6,0,1.1,0.3,1.3,0.8l14.4,29l32.1,4.6    c0.6,0.1,1,0.5,1.2,1c0.2,0.5,0,1.1-0.4,1.5L75,60.2l5.6,31.9c0.1,0.6-0.1,1.1-0.6,1.5c-0.5,0.3-1.1,0.4-1.6,0.1l-28.7-15L21,93.9    C20.8,94,20.6,94,20.3,94z M5.2,37.7l21.7,21c0.4,0.3,0.5,0.8,0.4,1.3l-5,29.7L49,75.7c0.4-0.2,1-0.2,1.4,0l26.7,14l-5.2-29.7    c-0.1-0.5,0.1-1,0.4-1.3l21.5-21.1L64,33.2c-0.5-0.1-0.9-0.4-1.1-0.8l-13.4-27L36.2,32.5c-0.2,0.4-0.6,0.8-1.1,0.8L5.2,37.7z"></path>  <path d="M20.3,94.5c-0.4,0-0.8-0.1-1.2-0.4c-0.6-0.4-0.9-1.2-0.8-2l5.3-31.7L0.6,38.1c-0.6-0.5-0.7-1.3-0.5-2    c0.2-0.7,0.9-1.3,1.6-1.4L33.5,30L47.7,1.1C48,0.4,48.7,0,49.4,0c0.8,0,1.5,0.4,1.8,1.1l14.3,28.8l31.8,4.5    c0.8,0.1,1.4,0.6,1.6,1.4c0.2,0.7,0,1.5-0.5,2.1l-23,22.5L81.1,92c0.1,0.7-0.2,1.5-0.8,2c-0.6,0.5-1.4,0.5-2.1,0.2L49.7,79.3    l-28.4,15C21,94.5,20.7,94.5,20.3,94.5z M49.5,1c-0.4,0-0.7,0.2-0.9,0.6L34.2,30.9L1.9,35.7C1.5,35.8,1.2,36,1,36.4    c-0.1,0.4,0,0.8,0.3,1l23.5,22.7l-5.4,32.2c-0.1,0.4,0.1,0.8,0.4,1c0.3,0.2,0.7,0.2,1.1,0.1l28.9-15.3l29,15.1    c0.3,0.2,0.7,0.1,1.1-0.1c0.3-0.2,0.5-0.6,0.4-1L74.5,60l0.2-0.2l23.1-22.7c0.3-0.3,0.4-0.7,0.2-1c-0.1-0.4-0.4-0.6-0.8-0.7    l-32.4-4.6l-0.1-0.2l-14.4-29C50.2,1.2,49.8,1,49.5,1z M21.7,90.7L26.8,60c0.1-0.3-0.1-0.7-0.3-0.9L4.2,37.4L35,32.8    c0.3,0,0.6-0.3,0.8-0.5l13.7-28l13.9,27.9c0.1,0.3,0.4,0.5,0.8,0.5L95,37.1L72.7,58.9c-0.2,0.2-0.3,0.6-0.3,0.9l5.4,30.7    L50.1,76.1c-0.3-0.2-0.6-0.2-0.9,0L21.7,90.7z M6.3,38.1l20.9,20.3c0.5,0.5,0.7,1.1,0.6,1.8L23,88.9l25.8-13.6    c0.6-0.3,1.3-0.3,1.9,0l25.8,13.5l-5-28.7c-0.1-0.6,0.1-1.3,0.6-1.8l20.8-20.4L64,33.7c-0.7-0.1-1.2-0.5-1.5-1.1l-13-26.1    L36.6,32.7c-0.3,0.6-0.9,1-1.5,1.1L6.3,38.1z"></path></svg>            </span>            <span>Home Store:</span><span class="home_store--name">' + new_home_store.name + '</span> (' + new_home_store.mall + ')  </p>');
    if(new_home_store.pcode !== false){

      var data = {
          'province_code': null,
          'city':null,
          //'pcode': new_home_store.pcode,
          'lat': new_home_store.lat,
          'lng': new_home_store.lng,
          'range': 50
      };

      $.ajax({
        url: 'https://web01.thingsengraved.ca/_apps/locator_ajax.php?get-store-data',
        //dataType: "jsonp",
        method: 'post',
        crossDomain: true,
        data:data
        })
        .done(function(data) {
          $('#stores-close-to').text(new_home_store.name + ' (' +new_home_store.mall+')');
          refresh_map_markers(data);
      });
    }
  }

  function refresh_map_markers(data){

    $allmarkers.forEach(function(marker) {
      marker.setMap(null);
    });

    markers = [];

    var mapMarker = $('.store-locator__map').attr('data-marker-icon');
    var mapHomeMarker = $('.store-locator__map').attr('data-home-marker-icon');

    var mapGPSMarker = $('.store-locator__map').attr('data-your-location-marker-icon');
    $('.store__list').empty();

    var closeModal = function() {
      $('.modal__containter').removeClass('modal__open');
      $('.modal').removeClass('visible');
      $('.modal').addClass('transition');
      setTimeout(function(){
        $('.modal').removeClass('transition');
        $('.modal').addClass('hide');
      },500);
    }

    // Close Modal
    $('.modal__close').on('click', function(e){
      e.preventDefault();
      closeModal();
    });

    $(document).keydown(function(e){
      if(e.keyCode == 27) {
        closeModal();
      }
    });

    if(document.getElementById("store-locator_list") !== null) {

      $.each(data.json, function( key, value ) {
        $.each(value, function( k, v ) {
          safe = v;
          safe.mall = v.mall.replace('\'', '&#39;');
          safe.address = v.address.replace('\'', '&#39;');
          tempMarker = mapMarker;

          if(home_store && v.whsenum == home_store.whsenum){
            tempMarker = mapHomeMarker;
          }

          var distance = '';

          if(typeof v.distance !== 'undefined'){
            distance = 'Distance '+ v.distance.substring(0,3)+' km';
          }

          $('.store__list').append('<li id="store_'+v.whsenum+'" class="'+(home_store && v.whsenum == home_store.whsenum ? 'home ' : '' )+'">'+
            '<p class="store__name">'+
              '<a href="#" data-store-id="' + v.whsenum + '"  class="btn__details">' + v.name + '<br/>(' + v.mall+ ')</a>'+
            '</p>'+
            '<p class="store__location">'+
              '<a href="https://www.google.ca/maps/search/' + encodeURIComponent(v.address + ',' + v.city + ',' + v.prov + ' ' + v.pcode) + '">'+v.address+' <br />'+v.city+', '+v.prov+' '+v.pcode+'</a>'+
            '</p>'+
            '<a href="tel:'+v.phone+'">'+v.phone+'</a>'+
            '<p class="store__distance">'+
              distance +
              '<span>'+
                '<a href="https://www.google.ca/maps/search/' + encodeURIComponent(v.address + ',' + v.city + ',' + v.prov + ' ' + v.pcode) + '" target="_blank">' + (home_store && v.whsenum !== home_store.whsenum ? '<svg class="icon icon__map-marker" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="12.4px" height="18px" viewBox="0 0 12.4 18" style="enable-background:new 0 0 12.4 18;" xml:space="preserve">'+
                  '<path d="M6.2,18c-0.2,0-0.4-0.1-0.5-0.2C5.5,17.4,0,10.4,0,6.8C0,3,2.8,0,6.2,0c3.4,0,6.2,3,6.2,6.8 c0,3.6-5.5,10.6-5.7,10.9C6.6,17.9,6.4,18,6.2,18z M6.2,1.2c-2.8,0-5,2.5-5,5.6c0,2.4,3.3,7.2,5,9.6c1.7-2.3,5-7.2,5-9.6 C11.2,3.7,9,1.2,6.2,1.2z"/>'+
                  '<path d="M6.2,9.6c-1.6,0-2.9-1.3-2.9-2.9s1.3-2.9,2.9-2.9s2.9,1.3,2.9,2.9S7.8,9.6,6.2,9.6z M6.2,4.9 c-0.9,0-1.7,0.8-1.7,1.7s0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7S7.2,4.9,6.2,4.9z"/>'+
                '</svg>' : '<svg version="1.1" class="icon icon__star" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="99.1px" height="94.5px" viewBox="0 0 99.1 94.5" style="enable-background:new 0 0 99.1 94.5;" xml:space="preserve">  <path d="M20.3,94c-0.3,0-0.6-0.1-0.9-0.3c-0.5-0.3-0.7-0.9-0.6-1.5l5.4-32L1,37.8c-0.4-0.4-0.6-1-0.4-1.5    c0.2-0.5,0.6-0.9,1.2-1l32.1-4.8L48.1,1.3c0.3-0.5,0.8-0.8,1.3-0.8c0,0,0,0,0,0c0.6,0,1.1,0.3,1.3,0.8l14.4,29l32.1,4.6    c0.6,0.1,1,0.5,1.2,1c0.2,0.5,0,1.1-0.4,1.5L75,60.2l5.6,31.9c0.1,0.6-0.1,1.1-0.6,1.5c-0.5,0.3-1.1,0.4-1.6,0.1l-28.7-15L21,93.9    C20.8,94,20.6,94,20.3,94z M5.2,37.7l21.7,21c0.4,0.3,0.5,0.8,0.4,1.3l-5,29.7L49,75.7c0.4-0.2,1-0.2,1.4,0l26.7,14l-5.2-29.7    c-0.1-0.5,0.1-1,0.4-1.3l21.5-21.1L64,33.2c-0.5-0.1-0.9-0.4-1.1-0.8l-13.4-27L36.2,32.5c-0.2,0.4-0.6,0.8-1.1,0.8L5.2,37.7z"></path>  <path d="M20.3,94.5c-0.4,0-0.8-0.1-1.2-0.4c-0.6-0.4-0.9-1.2-0.8-2l5.3-31.7L0.6,38.1c-0.6-0.5-0.7-1.3-0.5-2    c0.2-0.7,0.9-1.3,1.6-1.4L33.5,30L47.7,1.1C48,0.4,48.7,0,49.4,0c0.8,0,1.5,0.4,1.8,1.1l14.3,28.8l31.8,4.5    c0.8,0.1,1.4,0.6,1.6,1.4c0.2,0.7,0,1.5-0.5,2.1l-23,22.5L81.1,92c0.1,0.7-0.2,1.5-0.8,2c-0.6,0.5-1.4,0.5-2.1,0.2L49.7,79.3    l-28.4,15C21,94.5,20.7,94.5,20.3,94.5z M49.5,1c-0.4,0-0.7,0.2-0.9,0.6L34.2,30.9L1.9,35.7C1.5,35.8,1.2,36,1,36.4    c-0.1,0.4,0,0.8,0.3,1l23.5,22.7l-5.4,32.2c-0.1,0.4,0.1,0.8,0.4,1c0.3,0.2,0.7,0.2,1.1,0.1l28.9-15.3l29,15.1    c0.3,0.2,0.7,0.1,1.1-0.1c0.3-0.2,0.5-0.6,0.4-1L74.5,60l0.2-0.2l23.1-22.7c0.3-0.3,0.4-0.7,0.2-1c-0.1-0.4-0.4-0.6-0.8-0.7    l-32.4-4.6l-0.1-0.2l-14.4-29C50.2,1.2,49.8,1,49.5,1z M21.7,90.7L26.8,60c0.1-0.3-0.1-0.7-0.3-0.9L4.2,37.4L35,32.8    c0.3,0,0.6-0.3,0.8-0.5l13.7-28l13.9,27.9c0.1,0.3,0.4,0.5,0.8,0.5L95,37.1L72.7,58.9c-0.2,0.2-0.3,0.6-0.3,0.9l5.4,30.7    L50.1,76.1c-0.3-0.2-0.6-0.2-0.9,0L21.7,90.7z M6.3,38.1l20.9,20.3c0.5,0.5,0.7,1.1,0.6,1.8L23,88.9l25.8-13.6    c0.6-0.3,1.3-0.3,1.9,0l25.8,13.5l-5-28.7c-0.1-0.6,0.1-1.3,0.6-1.8l20.8-20.4L64,33.7c-0.7-0.1-1.2-0.5-1.5-1.1l-13-26.1    L36.6,32.7c-0.3,0.6-0.9,1-1.5,1.1L6.3,38.1z"></path></svg>') + '</a>'+
              '</span>'+
            '</p>'+
            '<div class="store__home">'+
              '<a href="#" data-store-id="' + v.whsenum + '"  class="btn btn__details btn__tertiary">Store Details +</a>'+ (home_store && v.whsenum == home_store.whsenum ? '' :
              '<a data-store=\'' + JSON.stringify(safe) + '\' class="btn btn__home-store btn__tertiary">Set Home Store</a>')+
            '</div>'+
          '</li>');

          $('.btn__home-store').off('click');
          $('.btn__home-store').on('click',function(){
            setHomeStore($(this).data('store'), false);
          });

          $('.store-locator__map').append('<div class="marker" data-marker-id="'+v.whsenum+'" data-lat="'+v.lat+'" data-lng="'+v.lng+'" data-marker-icon="'+tempMarker+'"></div>');

        });
      });

      if (here_marker_pos !== false) {
        $('.store-locator__map').append('<div class="marker" data-lat="'+here_marker_pos.lat+'" data-lng="'+here_marker_pos.lng+'" data-marker-icon="'+mapGPSMarker+'"></div>');
      }

      if ($('#map').length !== 0) {
        render_map( $('#map') );
        initAutocompleteMap();
      }

      $('.btn__details').on('click', function(e){
        e.preventDefault();
        //$('.modal__containter:not(#newsletter_popup)').addClass('modal__open');
        $('#store_details').addClass('modal__open');
        $('.modal__body').hide();
        $('.modal__body--loading').show();
        $.ajax({
          url: 'https://api.thingsengraved.com/api/store/' + $(this).data('store-id'),
          method: 'get',
          crossDomain: true
          })
          .done(function(data) {
            data = JSON.parse(data);
            $('#store__mall').html(data.Mall);
            $('#store__mall-address').html(data.Store_Address.Address + "<br />" + data.Store_Address.City + ", " + data.Store_Address.Province + ' ' + data.Store_Address.Postal_Code + "<br />" + data.Phone_Number);
            var hours_string = '';
            $.each(data.Store_Hours.Summary, function(index,hour){
              hours_string += "<p>" + hour + "</p>";
            });
            $('#store__mall-hours').html(hours_string);
            //$('#store__location-tip').html()
            var services_string = '';
            $.each(data.Services, function(index,service){
              services_string += "<li>" + service.Description + "</li>";
            });
            $('#store__services').html(services_string);
            //$('#store__image').css('background-image', 'url(' + data.Images[0] + ')');
            $('#store__image').attr('style','background-image: url(' + data.Images[0] + ')');

            $('.modal__body').show();
            $('.modal__body--loading').hide();
          });
        setTimeout(function(){
          $('#store_details .modal').removeClass('hide');
          $('#store_details .modal').addClass('transition');
        });
        setTimeout(function(){
          $('#store_details .modal').removeClass('transition');
          $('#store_details .modal').addClass('visible');
          },50);
      });


      $('.store-locator .tab__view').on('click', function(){
        var view_type = $(this).attr('data-view');

        $('.store-locator .tab__view').removeClass('active');
        $(this).addClass('active');

        if(view_type == 'map-view') {
          $('.store-locator__list').removeClass('active');
          $('.store-locator__map').addClass('active');
        } else {
          $('.store-locator__map').removeClass('active');
          $('.store-locator__list').addClass('active');
        }
      });
    }
  }

  function render_map( $el ) {
    var $markers = $el.find('.marker');
    var args = {
      center            : new google.maps.LatLng(45.346734,  -75.813461),
      scrollwheel       : true,
      zoomControl       : true,
      streetViewControl : true,
      navigationControl : true,
      mapTypeControl    : false,
      scaleControl      : true,
      draggable         : true,
      mapTypeId         : google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true
    };

    var styles = [
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e9e9e9"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "landscape",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 17
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 29
                            },
                            {
                                "weight": 0.2
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 18
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dedede"
                            },
                            {
                                "lightness": 21
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "color": "#ffffff"
                            },
                            {
                                "lightness": 16
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "saturation": 36
                            },
                            {
                                "color": "#333333"
                            },
                            {
                                "lightness": 40
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f2f2f2"
                            },
                            {
                                "lightness": 19
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 20
                            }
                        ]
                    },
                    {
                        "featureType": "administrative",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#fefefe"
                            },
                            {
                                "lightness": 17
                            },
                            {
                                "weight": 1.2
                            }
                        ]
                    }
                ];
    var styledMap = new google.maps.StyledMapType(styles, {name: "Things Engraved Style"});
    gmap = new google.maps.Map( $el[0], args);
    gmap.mapTypes.set('map_style', styledMap);
    gmap.setMapTypeId('map_style');

    gmap.markers = [];

    $markers.each(function(){
        add_marker( $(this), gmap);
    });
    center_map( gmap );
    gmap.addListener('dragstart',function(e){
      $('.store__list li').removeClass('selected');
    });
  }


  function add_marker( $marker, map ) {
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
    var data_id = $marker.attr('data-id');
    var cat = $marker.attr('data-cat');
    var marker_icon = $marker.attr('data-marker-icon');
    var marker_id = $marker.attr('data-marker-id');
    var marker = new google.maps.Marker({
      position  : latlng,
      map       : map,
      icon      : marker_icon
    });

    if (!(cat in $markgroups)) {
      $markgroups[cat] = [];
    }

    $markgroups[cat].push( marker );
    $allmarkers.push( marker );
    map.markers.push( marker );
    //oms.addMarker(marker);


    google.maps.event.addListener(marker, 'click', function() {
      $('.store__list li').removeClass('selected');
      $('.store-locator__map').removeClass('active');
      $('.store-locator__list').addClass('active');
      $('.store__list').animate({
          scrollTop: $("#store_" + marker_id).position().top - $('.store__list').position().top + $('.store__list').scrollTop()
      }, 500);
      $("#store_" + marker_id).addClass('selected');
    });


  }

  function center_map(map) {
    var bounds = new google.maps.LatLngBounds();
    $.each( map.markers, function( i, marker ){
      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
      bounds.extend( latlng );
    });
    if ( map.markers.length == 1 ){
      map.setCenter( bounds.getCenter() );
      map.setZoom( 10 );
    } else {
      map.fitBounds( bounds );
    }
  }

  function initAutocompleteMap() {

    var input = document.getElementById('pac-input');
    var options = {
        componentRestrictions: {country: 'ca'}
    };

    var searchBox = new google.maps.places.Autocomplete(input,options);


    searchBox.addListener('place_changed', function() {
      var places = [searchBox.getPlace()];

      if (places.length == 0) {
        return;
      }
      var postal_code = false;
      var city = false;
      var province = false;
      places[0].address_components.forEach(function(component) {
        switch(component.types[0]) {
          case 'postal_code':
          case 'postal_code_prefix':
            postal_code = component.long_name;
            if(postal_code.length == 3){
              postal_code += ' 2A2';
            }
            break;
          case 'administrative_area_level_1':
            province = component.short_name;
            break;
        }
      });
      var data = {
          'province_code': null,
          'city':null,
          'pcode': null,
          'lat': places[0].geometry.location.lat(),
          'lng': places[0].geometry.location.lng(),

          'range': 50
      };

      if(province !== false && places[0].address_components.length == 2){
        data = {
            'province_code': province,
            'city':null,
            'pcode': null,
            'lat': null,
            'lng': null,
            'range': null
        };
      }
      here_marker_pos = {
        lat: places[0].geometry.location.lat(),
        lng: places[0].geometry.location.lng()
      };
      if(postal_code == false){
        if(typeof places[0].vicinity !== 'undefined'){
          //data.city = places[0].vicinity;
        } else {
          //data.province_code = province;
        }
      } else {
        //data.pcode = postal_code;
      }


      $.ajax({
        url: 'https://web01.thingsengraved.ca/_apps/locator_ajax.php?get-store-data',
        //dataType: "jsonp",
        method: 'post',
        crossDomain: true,
        data:data
        })
        .done(function(data) {
          $('#stores-close-to').text(places[0].name);
          if(data.json.length == 0){

          var geocoder = new google.maps.Geocoder();
          var postal_code = false;
          geocoder.geocode({'location': here_marker_pos}, function(results,status){
            if(postal_code == false){
              $.each(results,function(index,location){
                $.each(location.address_components,function(index,component) {
                  switch(component.types[0]) {
                    case 'postal_code':
                    case 'postal_code_prefix':
                      postal_code = component.long_name;
                      if(postal_code.length == 3){
                        postal_code += ' 2A2';
                      }
                      break;
                  }
                });
              });
            }
            if(postal_code !== false){
              var data = {
                  'province_code': null,
                  'city':null,
                  // 'pcode': postal_code,
                  'lat': here_marker_pos.lat,
                  'lng': here_marker_pos.lng,
                  'range': 150
              };

              // Clear out the old markers.
              $.ajax({
                url: 'https://web01.thingsengraved.ca/_apps/locator_ajax.php?get-store-data',
                //dataType: "jsonp",
                method: 'post',
                crossDomain: true,
                data:data
                })
                .done(function(data) {
                  $('#stores-close-to').text('Your Current location');
                  refresh_map_markers(data);
              });
            }
          });
        } else {
          refresh_map_markers(data);
        }
      });
    });
  }
});

function update_product_stock_indicator(){
  $('#home_store--not-set').hide();
  $('#home_store--set--in-stock').hide();
  $('#home_store--set--out-of-stock').hide();
  if(availability == 'online' || availability == 'special'){
    return;
  }
  $.ajax({
    url: api_url + '/stock/' + current_sku +"?stores=" + home_store.whsenum,
    //dataType: "jsonp",
    crossDomain: true
    })
    .done(function(data) {
      data = JSON.parse(data);
      if(typeof data.Status !== "undefined" && data.Status == "No Data"){
        $('#home_store--set--out-of-stock').show();
      } else if(data.length > 0 ){
        if(data[0].Quantity >= min_store_stock)
        {
          $('#home_store--set--in-stock').show();
        } else {
          $('#home_store--set--out-of-stock').show();
        }
      }
    });
}

function makeFooter(state) {
  var modalFooters = Array.from(document.querySelectorAll('.js-modal-footer'));

  if (state === 'visible') {
    modalFooters.forEach(function(footer) {
      footer.classList.add('is-visible');
    })
  } else if (state === 'hidden') {
    modalFooters.forEach(function(footer) {
      footer.classList.remove('is-visible');
    })
  }
};

function updateChangeHomeStore(storeIsSet) {
  var makeHomeStoreBtn = Array.from(document.querySelectorAll('.js-make-home-store'));
  var storeList = document.querySelector('.js-store-list');
  var changeHomeStoreBtns = Array.from(document.querySelectorAll('.js-change-home-store'));
  var homeStoreHeader = document.querySelector('.js-home-store-header');
  var modalSearchForm = document.querySelector('.modal__change-store .search__form');

  homeStoreHeader.style.display = 'none';
  modalSearchForm.classList.add('has-border');
  storeList.classList.remove('reduced-height');
    
  if (storeList.length) {
    updateText(changeHomeStoreBtns, 'Change Your Home Store')
    homeStoreHeader.style.display = 'block';
    modalSearchForm.classList.remove('has-border');
    storeList.classList.add('reduced-height');
    makeFooter('visible');
  } else if (storeIsSet) {
    updateText(changeHomeStoreBtns, 'Change Your Home Store')
    homeStoreHeader.style.display = 'block';
    modalSearchForm.classList.remove('has-border');
    storeList.classList.add('reduced-height');
    makeFooter('visible');
  } else {
    updateText(changeHomeStoreBtns, 'Set Your Home Store')
  }

  makeHomeStoreBtn.forEach(function(btn) {
    btn.addEventListener('click', updateText(changeHomeStoreBtns, 'Change Your Home Store'));
  });
}

function updateText(elements, text) {
  elements.forEach(function(btn) {
    btn.innerText = text;
  });
}